"use client";

import { c as _c } from "react/compiler-runtime";
import { Completion, CompletionHeader } from "../components/completion";
import { Button } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
export function WaitlistComplete() {
  const $ = _c(4);
  const {
    startOver
  } = useSelfScheduleContext();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CompletionHeader title="You're on the waitlist"><p>Your preferences are saved. The clinic will be in touch when an appointment becomes available.</p></CompletionHeader>;
    t1 = <p className="text-center text-caption text-foreground-muted">No appointment has been booked.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== startOver) {
    t2 = <Completion testId="step-waitlist-complete">{t0}{t1}<div className="mt-8 flex justify-center"><Button variant="primary" onClick={startOver}>Start over</Button></div></Completion>;
    $[2] = startOver;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}